import { Factory } from '../Factory';

export enum FormFactor {
  PortraitPhone = 0,
  LandscapePhone = 1,
  PortraitTablet = 2,
  LandscapeTablet = 3,
  LargeDesktop = 4
  }

export class ResponsiveDesignService implements IService {
  constructor(window: angular.IWindowService, rootScope: IRootScope) {
    this._width = window.innerWidth;
    this._height = window.innerHeight;

    angular.element(window).on("resize", _.debounce(() => {
      this._width = window.innerWidth;
      this._height = window.innerHeight;

      if (this._width >= 1200) {
        this._formFactor = FormFactor.LargeDesktop;
      } else if (this._width <= 1199 && this._width >= 980) {
        this._formFactor = FormFactor.LandscapeTablet;
      } else if (this._width <= 979 && this._width >= 768) {
        this._formFactor = FormFactor.PortraitTablet;
      } else if (this._width <= 767 && this._width >= 481) {
        this._formFactor = FormFactor.LandscapePhone;
      } else if (this._width <= 480) {
        this._formFactor = FormFactor.PortraitPhone;
      }

      rootScope.$broadcast("ResponsiveDesignService.WindowResized")
    }, 300));
  }

  private _width: number;

  public get width(): number {
    return this._width;
  }

  private _height: number;

  public get height(): number {
    return this._height;
  }

  private _formFactor: FormFactor;

  public get formFactor(): FormFactor {
    return this._formFactor;
  }
}

frontendApp.factory("ResponsiveDesignService", ["$window", "$rootScope", Factory.Create(ResponsiveDesignService)]);

